import ArrowDown from './arrow-down.svg?react';
import ArrowLeft from './arrow-left.svg?react';
import ArrowRight from './arrow-right.svg?react';
import ArrowRightLong from './arrow-right-long.svg?react';
import ArrowUp from './arrow-up.svg?react';
import Attachment from './attachment.svg?react';
import Bullseye from './bullseye.svg?react';
import Calendar from './calendar.svg?react';
import CheckmarkCircle from './checkmark-circle.svg?react';
import CheckmarkCircleFill from './checkmark-circle-fill.svg?react';
import Checkmark from './checkmark.svg?react';
import ChevronDownFAQ from './chevron-down-faq.svg?react';
import ChevronDown from './chevron-down.svg?react';
import ChevronLeft from './chevron-left.svg?react';
import ChevronRight from './chevron-right.svg?react';
import ChevronUp from './chevron-up.svg?react';
import Clock from './clock.svg?react';
import Close from './close.svg?react';
import ClosedCircle from './closed-circle.svg?react';
import Copy from './copy.svg?react';
import DollarSign from './dollar-sign.svg?react';
import Download from './download.svg?react';
import Edit from './edit.svg?react';
import Email from './email.svg?react';
import Error from './error.svg?react';
import EyeClosed from './eye-closed.svg?react';
import EyeOpen from './eye-open.svg?react';
import Flow from './flow.svg?react';
import Flow2 from './flow2.svg?react';
import Filter from './filter.svg?react';
import Hamburger from './hamburger.svg?react';
import Heart from './heart.svg?react';
import Home from './home.svg?react';
import Info from './info.svg?react';
import Link from './link.svg?react';
import Lightning from './lightning.svg?react';
import Minus from './minus.svg?react';
import MinusCircle from './minus-circle.svg?react';
import Money from './money.svg?react';
import Peace from './peace.svg?react';
import Percent from './percent.svg?react';
import Phone from './phone.svg?react';
import PlusCircle from './plus-circle.svg?react';
import Plus from './plus.svg?react';
import PopOut from './pop-out.svg?react';
import Search from './search.svg?react';
import Sync from './sync.svg?react';
import User from './user.svg?react';
import Warning from './warning.svg?react';
import Twitter from './twitter.svg?react';
import Linkedin from './linkedin.svg?react';
import Instagram from './instagram.svg?react';
import Facebook from './facebook.svg?react';
import Upload from './upload.svg?react';
import QuestionMark from './question-mark.svg';

export {
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowRightLong,
  ArrowUp,
  Attachment,
  Bullseye,
  Calendar,
  CheckmarkCircle,
  CheckmarkCircleFill,
  Checkmark,
  ChevronDown,
  ChevronDownFAQ,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Clock,
  Close,
  ClosedCircle,
  Copy,
  DollarSign,
  Download,
  Edit,
  Email,
  Error,
  EyeClosed,
  EyeOpen,
  Flow,
  Flow2,
  Filter,
  Hamburger,
  Heart,
  Home,
  Info,
  Link,
  Lightning,
  Minus,
  MinusCircle,
  Money,
  Peace,
  Percent,
  Phone,
  PlusCircle,
  Plus,
  PopOut,
  Search,
  Sync,
  User,
  Warning,
  Twitter,
  Linkedin,
  Instagram,
  Facebook,
  Upload,
  QuestionMark
};
